const animate = (config) => {
	// Get elements with data-animation-group attrib
	const animationItems = document.querySelectorAll(`[data-animation-group="${config.name}"]`);

	const getClassFromAttrib = (element) => {
		// Get value from data-animation attrib
		const className = element.getAttribute('data-animation');

		// Check if attrib value is empty string. If true return opacity animation as default
		if (className === '') return 'opacity';
		else return className;
	};

	// Set up oberver options
	const options = config.options;

	// Init observer
	const observer = new IntersectionObserver((entries, observer) => {
		entries.forEach((entry) => {
			// Check if item is in viewport
			if (entry.isIntersecting) {
				if (entry.target.hasAttribute('data-animation')) {
					entry.target.classList.add(getClassFromAttrib(entry.target));
				}

				console.log(entry.target);

				// Get all item children with data-animation attrib
				entry.target.querySelectorAll('[data-animation]').forEach((elem) => {
					// Add animation class
					elem.classList.add(getClassFromAttrib(elem));
					// Stop observing
					observer.unobserve(entry.target);
				});
			}
		});
	}, options);

	// Prepare elements before animation
	document.querySelectorAll('[data-animation]').forEach((elem) => {
		// Add animation class with __before
		elem.classList.add(`${getClassFromAttrib(elem)}__before`);
	});

	// Observe the animation groups to be placed in the viewport
	animationItems.forEach((item) => observer.observe(item));
};

export default animate;
